export default {
  'satabapp-research': {},
  'satabapp-company': {},
  'satabapp-user': {},
  'satabapp-customer': {},
  'satabapp-token': '',
  'satabapp-translation': '',
};